import React, {Suspense, useEffect, useState} from "react";
import {Route, Routes , useLocation} from "react-router-dom";

// import Support from "./pages/Support/Support";
import ScrollToTop from "./utils/utils";
import {useNavigate} from "react-router";
import {getVersionData} from "./services/api/DataFetching";
import {store} from "./index";
import {setVersionAction} from "./store/Actions/CommonAction";



//import MobileFAQForm from "./pages/FAQ/MobileFAQForm";

import { loadAllNonCriticalCSS } from "./utils/cssLoader";
 

import {useMediaQuery} from "react-responsive";
import ScrollArrow from "../src/assets/icons/arrow-scroll-up.svg"
import cogoToast from "cogo-toast";
import {CustomToast} from "./components/CustomToast/CustomToast";
import ReviewPaymentContextProvider from "./hooks/context/review-payment-context";
import BookingLayout from "./layout/BookingLayout/BookingLayout";

const PageNotFound = React.lazy(() => import("./pages/PageNotFound/PageNotFound"));
const CouponList = React.lazy(() => import("./pages/CouponList/CouponList"));
const EnvironmentPage = React.lazy(() => import("./pages/EnvironmentPage/Environments"));
const Careers = React.lazy(() => import("./pages/Careers/Careers"));
const AboutUsPage = React.lazy(() => import("./pages/AboutUsPage/AboutUsPage"));
const News = React.lazy(() => import("./pages/Newsroompage/News"));
const PartnerWithUs = React.lazy(() => import("./pages/PartnerWithUs/PartnerWithUs"));
const Blog = React.lazy(() => import("./pages/Blog/BlogLandingPage/Blog"));
const SpecificBlog = React.lazy(() => import("./pages/Blog/SpecificBlogs/GeneralSpecificBlog"));
const DesktopFAQForm = React.lazy(() => import("./pages/FAQ/DesktopFaqForm"));
 const FAQDetails = React.lazy(() => import("./pages/FAQDetailsPage/FADetails"));
const DownloadApp = React.lazy(() => import("./pages/DownloadApp/DownloadApp"));
const TermConditions = React.lazy(() => import("./pages/TermConditions/TermConditions"));
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy/PriacyPolicy"));
const Faq = React.lazy(() => import("./pages/FAQ/FAQ"));

const NoRoute404 = React.lazy(() => import("./pages/NoRoute404/NoRoute404"));

const Sitemap = React.lazy(()=>import("./pages/Sitemap/Sitemap"));

const AllnewsComponent = React.lazy(()=>import("./pages/Newsroompage/components/AllnewsComponent"));
const SpecificNewsPage = React.lazy(() => import("./pages/Newsroompage/SpecificNewsPage"));

const K2K = React.lazy(() => import("./pages/K2K/K2K"));
const Settings = React.lazy(()=> import("./pages/Settings/Settings")); 
 const ChangeBookingPage = React.lazy(()=>import("./pages/ChangeBookingPage/ChangeBookingPage"));

const RescheduleConfirmation = React.lazy(()=>import("./pages/Confirmation/RescheduleConfirmation"));
const OfferListPageDesktop = React.lazy(()=>import("./pages/OfferListPageDesktop/OfferListPageDesktop"));
const QrPage = React.lazy(()=>import("./pages/QrPage/QrPage"));
const ProfileDetail = React.lazy(() => import("./pages/ProfileDetail/ProfileDetail"));
const Lounge = React.lazy(() => import("./pages/Lounge/Lounge"));
const AddMoneyResultPage = React.lazy(() => import("./pages/AddMoneyResultPage/AddMoneyResultPage"));
const TicketDetailPage = React.lazy(() => import("./pages/TicketDetailPage/TicketDetailPage"));
const CompletedTrip = React.lazy(() => import("./pages/CompletedTrip/CompletedTrip"));
const CoPassengerDetailPage = React.lazy(() => import("./pages/CoPassengerDetailPage/CoPassengerDetailPage"));
const ChecklistPageMobile = React.lazy(() => import("./pages/ChecklistPageMobile/ChecklistPageMobile"));
const ChecklistDetailPageMobile = React.lazy(() => import("./pages/ChecklistPageMobile/ChecklistDetailPageMobile"));
const FnBConfirmation = React.lazy(() => import("./pages/F&B/F&BConfirmation"));
const OfferAvailable = React.lazy(() => import("./pages/OfferAvailable/OfferAvailable"));
const BookingState = React.lazy(() => import("./pages/BookingStates/BookingState"));
const ChangeBookingSection = React.lazy(() => import("./pages/ChangeBooking/ChangeBooking"));
const GuestUserBookingMobile = React.lazy(() => import("./pages/GuestuserBookingMobile/GuestUserBookingMobile"));
const PaymentDeductedSeatNotBooked = React.lazy(() => import("./pages/PaymentDeductedSeatNotBooked/PaymentDeductedSeatNotBooked"));
const PaymentInProcess = React.lazy(() => import("./pages/PaymentInProcess/PaymentInProcess"));
const DistancePage = React.lazy(() => import("./pages/DistancePage/DistancePage"));


const Home = React.lazy(() => import("./pages/Home/Home"));
const Bookings = React.lazy(() => import("./pages/Bookings/Bookings"));
const Booking2 = React.lazy(() => import("./pages/Bookings/Booking2"))
// const BookingWA = React.lazy(() => import("./pages/Bookings/BookingWA"))
const SeatArrangementMobile = React.lazy(() =>
    import("./pages/SeatArrangementMobile/SeatArrangementMobile")
);
const BoardingAndDroppingMobile = React.lazy(() =>
    import("./pages/BoardingAndDroppingMobile/BoardingAndDroppingMobile")
);
const AllRoutes = React.lazy(() =>
    import("./pages/AllBusDestinationNew/AllBusDestinationNew")
);
const AllCity = React.lazy(() =>
    import("./pages/AllBusDestinationNew/AllCity")
);
const CoachDetailsNew = React.lazy(() => import("./pages/CoachDetailsNew/CoachDetailsNew"))
const ReviewAndPayment = React.lazy(() =>
    import("./pages/ReviewBookingAndPayment/ReviewAndPayment/ReviewAndPayment")
);
const PaymentMobile = React.lazy(() =>
    import("./pages/ReviewBookingAndPayment/PaymentMobile/PaymentMobile")
);
const Confirmation = React.lazy(() =>
    import("./pages/Confirmation/Confirmation")
);
const PaymentFailure = React.lazy(() =>
    import("./pages/PaymentFailure/PaymentFailure")
);
const MyBookings = React.lazy(() => import("./pages/MyBookings/MyBookings"));
const Wallet = React.lazy(() => import("./pages/Wallet/Wallet"));
const Magazine = React.lazy(()=>import("./pages/Magazine/MagzineHome"))
const Itinerary = React.lazy(()=>import("./pages/Itinerary/Itinerary"))
const Fnb = React.lazy(()=>import("./pages/F&B/F&B"))
const EcoContribution =  React.lazy(()=>import("./pages/EcoContribution/index"))

const LoadingAnimation = process.env.REACT_APP_CDN_LINK + "assets/images/Loading_Amination-white.gif"
 
const CombinedRoutes = () => {
    const navigate = useNavigate();
    const isDesktopOrLaptop = useMediaQuery({
        query: "(min-width: 1024px)",
    });
 
    const [installPromptEvent, setInstallPromptEvent] = useState(null);
    let pathname = useLocation().pathname
 
    const scrollToTopArrow = ()=>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
    }
 
    useEffect(() => {
        getVersionData(
            (version) => {
                setTimeout(() => {
                    //navigate("/");
                    store.dispatch(setVersionAction(version));
                }, 1000);
            },
            (err) => {
                if(err){
                    // cogoToast.error(
                    //     <CustomToast
                    //         heading={"Error"}
                    //         message={err[0]?.message || err.toString()}
                    //         type={"error"}
                    //     />,
                    // );
                }
            }
        );
 
        // Load non-critical CSS after component mounts
        loadAllNonCriticalCSS();
 
        return () => {
        };
    }, [store?.getState()?.CommonReducer?.version]);
 
    useEffect(() => {
        const handleBeforeInstallPrompt = (event) => {
          event.preventDefault();
          setInstallPromptEvent(event);
        };
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
   
        return () => {
          window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
      },[]);
 
    return (
        //scroll to top on route change
        <ScrollToTop>
            <Suspense
                fallback={<></>
                    // <div
                    //     style={{height: "100vh", width: "100%"}}
                    //     className={"d-flex justify-content-center align-items-center"}
                    // >
                    //     <img src={LoadingAnimation} alt="loading"/>
                    // </div>
                }
            >          
                        {  //scroll to top on click of arrow
                        !isDesktopOrLaptop && pathname!=="/" && pathname!=="/booking" &&  pathname!=="/stops"&&
                        pathname!=="/seat-arrangement" && pathname!=="/payment" && pathname!=="/booking-details" && pathname!=="/profile-detail" && pathname!=='/my-booking' &&
                            <div onClick={scrollToTopArrow} className="scrollToTopArrow">
                                <img  src={ScrollArrow}/>
                            </div>
                        }
                <Routes>
                    <Route path={"/"} element={<Home/>}/>
                    <Route path={"/booking"} element={<BookingLayout><Bookings/></BookingLayout>}/>
                    <Route path="/booking/:id"   element={<BookingLayout><Booking2 /></BookingLayout>}/>
                    <Route path={"/seat-arrangement"} element={<SeatArrangementMobile/>}/>
                    <Route path={"/stops"} element={<BoardingAndDroppingMobile/>}/>
                    <Route path="/booking-details"   element={<BookingLayout><ReviewPaymentContextProvider><ReviewAndPayment/></ReviewPaymentContextProvider></BookingLayout>}/>
                    <Route path={"/payment"} element={<PaymentMobile/>}/>
                    <Route path={"/confirmation/:id"} element={<Confirmation/>}/>
                    <Route path={"/confirmation"} element={<Confirmation/>}/>
                   
                    <Route path={"/payment-processing/:id"} element={<PaymentInProcess/>}/>
                    <Route path={"/payment-processing"} element={<PaymentInProcess/>}/>
 
                    <Route path={"/failure/:id"} element={<PaymentFailure/>}/>
                    <Route path={"/failure"} element={<PaymentFailure/>}/>
                    <Route path={"/error"} element={<PageNotFound/>}/>
                    <Route path={"/kashmir-to-kanyakumari"} element={<K2K/>}/>
                   
 
                    {/* Blog  */}
                    <Route path={"/blog"} element={<Blog/>}/>
                    <Route path={"/blog/:id"} element={<SpecificBlog/>}/>
 
 
                    <Route path={"/coupon-list"} element={<CouponList/>}/>
                    <Route path={"/change-booking"} element={<ChangeBookingPage/>}/>
                    <Route path={"/reschedule/:id"} element={<RescheduleConfirmation/>}/>
                    <Route path={"/reschedule"} element={<RescheduleConfirmation/>}/>
                    <Route path={"/bus-booking-offers"} element={<OfferListPageDesktop/>}/>
                    <Route path={"/privacy-policy"} element={<PrivacyPolicy/>}/>
                    <Route path={"/support"} element={<DesktopFAQForm/>}/>
                    {/*<Route path={'/environment'} element={<PageEnvironment/>}/>*/}
                    <Route path={"/environment"} element={<EnvironmentPage/>}/>
                    <Route path={"/faq"} element={<Faq/>}/>
                    <Route path={"/terms-conditions"} element={<TermConditions />} />
                    <Route path={"/qr-code"} element={<QrPage/>}/>
                    <Route path={"/my-booking"} element={<MyBookings/>}/>
                    <Route path={"/all-routes"} element={<AllRoutes/>}/>
                    <Route path={"/city/:city"} element={<AllCity/>}/>
                    <Route path={"/all-routes/bus/:id"} element={<CoachDetailsNew child={installPromptEvent}/>}
                    />
                    {/*<Route path={"/about-us"} element={<AboutUs/>}/>*/}
                    <Route path={"/profile-detail"} element={<ProfileDetail/>}/>
                    <Route path={"/wallet"} element={<Wallet/>}/>
                    <Route path={"/travel-lounge"} element={<Lounge/>}/>
                    <Route path={"/recharge"} element={<AddMoneyResultPage/>}/>
                    <Route path={"/ticket-view"} element={<TicketDetailPage/>}/>
                    <Route path={"/careers"} element={<Careers/>}/>
                    <Route path={"/about-us"} element={<AboutUsPage/>}/>
                    <Route path={"/news"} element={<News/>}/>
                    <Route path={"/news/all-news"} element={<AllnewsComponent/>}/>
                    <Route path="/news/all-news/:id" element={<SpecificNewsPage/>}/>
                    <Route path={"/partner-with-us"} element={<PartnerWithUs/>}/>
                    <Route path={"/completed-trip"} element={<CompletedTrip/>}/>
                    <Route path={"/faq/:id"} element={<FAQDetails/>}/>
                    <Route path={"/booking-state"} element={<BookingState/>}/>
                    <Route path={"/offer-available"} element={<OfferAvailable/>}/>
                    <Route path={"/change-booking-section"} element={<ChangeBookingSection/>}/>
                    <Route path={"/download-app"} element={<DownloadApp/>}/>
                    <Route path={"/fnb"} element={<Fnb/>}/>
                    <Route path={"/fnbstatus"} element={<FnBConfirmation/>}/>
                    <Route path={"/co-passengers"} element={<CoPassengerDetailPage/>}/>
                    <Route path={"/settings"} element={<Settings/>}/>
                    <Route path={"/checklist"} element={<ChecklistPageMobile/>}/>
                    <Route path={"/checklist/:id"} element={<ChecklistDetailPageMobile/>}/>
                    <Route path={"/call"} element={<DesktopFAQForm/>}/>
                    <Route path={"/booking-failed"} element={<PaymentDeductedSeatNotBooked/>}/>
                    <Route path={"/booking-failed/:id"} element={<PaymentDeductedSeatNotBooked/>}/>
                    <Route path={"/guest-user"} element={<GuestUserBookingMobile/>}/>
                    <Route path={'/travel-itineraries'} element={<Magazine/>}/>
                    <Route path={"/travel-itineraries/:id"} element={<Itinerary/>}/>
                    <Route path={"/stops"} element={<BoardingAndDroppingMobile/>}/>
                    <Route path={"/seat-arrangement"} element={<SeatArrangementMobile/>}/>
                    <Route path={"/checklist"} element={<ChecklistPageMobile/>}/>
                    <Route path={"/checklist/:id"} element={<ChecklistDetailPageMobile/>}/>
                    <Route path={'/sitemap'} element={<Sitemap/>} />
                    <Route path={'/distance/:id'} element={<DistancePage/>} />
                    <Route path='*' element={<NoRoute404/>}/>
                    <Route path={"/eco-contribution"} element={<EcoContribution/>}/>
                </Routes>
            </Suspense>
        </ScrollToTop>
    );
};
 
export default CombinedRoutes;